import AppHeader from '../AppHeader'
import DayJs from 'dayjs'

export default {
  name: 'stepup-detail',
  created () {
    this.getStepUpDetail()
  },
  data () {
    return {
      stepUpEntry: '',
      stepUpOwnQuestion: '',
      stepUpQuestions: '',
      getStepupDetailEnd: false
    }
  },
  computed: {
    joinRestrictionDateFormat () {
      return DayJs(this.stepUpEntry.join_restriction_date).format('YYYY年MM月DD日')
    },
    shopRestrictionDateFormat () {
      return DayJs(this.stepUpEntry.shop_restriction_date).format('YYYY年MM月DD日')
    },
    notificationStartDateFormat () {
      return DayJs(this.stepUpEntry.notification_start_date).format('YYYY年MM月DD日')
    },
    answerStartDateFormat () {
      return DayJs(this.stepUpEntry.answer_start_date).format('YYYY年MM月DD日')
    },
    endDateFormat () {
      return DayJs(this.stepUpEntry.end_date).format('YYYY年MM月DD日')
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async getStepUpDetail () {
      let res = await this.$store.dispatch('GET_STEPUP_SHOW', { id: this.$route.params.id })
      .catch(err => {
        console.log(err)
        return
      })
      this.stepUpEntry = res.step_up_entry
      this.stepUpOwnQuestion = res.step_up_own_question
      this.stepUpQuestions = res.step_up_questions
      this.getStepupDetailEnd = true
    },
    goBack: function () {
      this.$router.push('/stepup_list')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/stepup-detail.js